import { FeatureFlags } from 'lib-shared-feature-flags';

import { AppState } from 'bootstrap.store';

import { hasFeature } from './hasFeature';
import { FeatureFlagConfig } from './types';

/**
 * Resolves a set of feature flags to one combined value. ----------------------
 * Strategy: 'all' - all feature flags must be true for the result to be true.
 * Strategy: 'any' - any feature flags must be true for the result to be true.
 *
 * @param state The app state.
 * @param flags The list of feature flags.
 * @param strategy The strategy to resolve the result of multiple feature flags.
 */

export function hasBooleanFeatures(
  rootStateOrFlags: AppState | FeatureFlags,
  flags: readonly FeatureFlagConfig[] = [],
  strategy = 'all',
): boolean {
  return flags
    .map(({ name, invert }) => {
      const hasFeatureFlag = hasFeature(rootStateOrFlags, name);
      return invert ? !hasFeatureFlag : hasFeatureFlag;
    })
    [strategy === 'all' ? 'every' : 'some'](Boolean);
}
